import React from 'react';

const SvgRegistered: React.FC<React.SVGProps<SVGSVGElement>> = props => (
  <svg viewBox="0 0 24 24" {...props}>
    <path
      d="M4 18.2704V16.404C4 15.9584 4.11221 15.569 4.33664 15.2359C4.56106 14.9028 4.85894 14.6421 5.23029 14.4537C5.94391
      14.0899 6.69736 13.7955 7.49061 13.5705C8.28388 13.3456 9.21924 13.2331 10.2967 13.2331C10.7165 13.2331 11.1069 13.2501
      11.468 13.284C11.8291 13.3179 12.1663 13.3687 12.4795 13.4365L11.3655 14.5505C11.2116 14.5225 11.045 14.5059 10.8658
      14.5005C10.6866 14.4951 10.4969 14.4924 10.2967 14.4924C9.30319 14.4924 8.43269 14.6033 7.68516 14.825C6.93763 15.0467
       6.312 15.2975 5.80826 15.5774C5.61775 15.6796 5.47863 15.7991 5.3909 15.9358C5.30318 16.0725 5.25932 16.2286 5.25932
       16.404V17.0111H10.3451L11.6044 18.2704H4ZM14.8755 18.8969L12.712 16.7334C12.4677 16.4891 12.4677 16.093 12.712
       15.8486C12.9563 15.6043 13.3525 15.6043 13.5968 15.8486L14.8755 17.1274L18.6729 13.33C18.9172 13.0857 19.3133 13.0857
       19.5576 13.33C19.802 13.5743 19.8019 13.9704 19.5576 14.2147L14.8755 18.8969ZM10.2967 11.8769C9.48861 11.8769 8.79685
       11.5891 8.22141 11.0137C7.64597 10.4383 7.35826 9.7465 7.35826 8.93844C7.35826 8.13036 7.64597 7.43861 8.22141
       6.86317C8.79685 6.28772 9.48861 6 10.2967 6C11.1047 6 11.7965 6.28772 12.3719 6.86317C12.9474 7.43861 13.2351 8.13036
       13.2351 8.93844C13.2351 9.7465 12.9474 10.4383 12.3719 11.0137C11.7965 11.5891 11.1047 11.8769 10.2967 11.8769ZM10.2967
       10.6176C10.7584 10.6176 11.1537 10.4531 11.4825 10.1243C11.8114 9.79549 11.9758 9.40019 11.9758 8.93844C11.9758 8.47668
       11.8114 8.08139 11.4825 7.75256C11.1537 7.42373 10.7584 7.25932 10.2967 7.25932C9.83491 7.25932 9.43962 7.42373 9.11079
       7.75256C8.78197 8.08139 8.61755 8.47668 8.61755 8.93844C8.61755 9.40019 8.78197 9.79549 9.11079 10.1243C9.43962 10.4531
       9.83491 10.6176 10.2967 10.6176Z"
      fill="#428FEF"
    />
  </svg>
);

export default SvgRegistered;
